import Store from "../storage/store";

export const store = new Store();
